<div class="loginHelpScreen">
  <idp-login-header
    [loginHeaderContent]="pageData?.loginHelpScreenView"
  ></idp-login-header>
  <div class="loginHelpScreen__content--container">
    <div class="loginHelpScreen__wrapper">
      <div class="loginHelpScreen__wrapper--text">
        {{ pageData?.loginHelpScreenView.forgotPasswordText }}
      </div>
      <idp-button
        [type]="'secondary'"
        class="loginHelpScreen__button"
        [label]="
          pageData?.loginHelpScreenView.nextDisplayView.button_resetPassword
        "
        (notify)="resetPassword()"
        [customClass]="'resetPasswordLoginHelpButton'"
      ></idp-button>
    </div>
    <div class="loginHelpScreen__section--line"></div>
    <div class="loginHelpScreen__wrapper">
      <div class="loginHelpScreen__wrapper--text">
        {{ pageData?.loginHelpScreenView.forgotLoginText }}
      </div>
      <idp-button
        [type]="'secondary'"
        class="loginHelpScreen__button"
        [label]="pageData?.loginHelpScreenView.nextDisplayView.button_sendLogin"
        (notify)="sendLogin()"
        [customClass]="'sendLoginHelpScreenButtton'"
      ></idp-button>
    </div>
    <div class="loginHelpScreen__section--line"></div>
    <!-- <div class="loginHelpScreen__wrapper">
      <div class="loginHelpScreen__wrapper--text">
        {{ pageData?.loginHelpScreenView.createPasswordText }}
      </div>
      <idp-button
        [type]="'secondary'"
        class="loginHelpScreen__button"
        [label]="
          pageData?.loginHelpScreenView.nextDisplayView.button_createPassword
        "
        (notify)="createPassword()"
      ></idp-button>
    </div>
    <div class="loginHelpScreen__section--line"></div> -->
  </div>
</div>
